

import URI from "urijs"
import _ from "lodash"
export default {
  getHref () {
    return window.location.href;
  },
  // hash 模式下
  // getQuery (key) {
  //   let href = this.getHref()
  //   if (href.indexOf('#') < 0) {
  //       return
  //   }
  //   let pathname = new URI(_.split(href, '#')[1])
  //   let uri = new URI(pathname)
  //   let query = uri.search(true)
  //   let value = _.get(query, key, '')
  //   value = _.isArray(value) ? value[0] : value
  //   return value
  // },
  getQuery (key) {
    let href =window.location.href;
    let uri = new URI(href)
    let query = uri.search(true)
    let value = _.get(query, key, '')
    value = _.isArray(value) ? value[0] : value
    return value
  },
  // hash模式下的setQuery
  // setQuery (key, value, replace=false) {
  //   let href = this.getHref()
  //   if (href.indexOf('#') < 0) {
  //       return
  //   }
  //   let pathname = new URI(_.split(href, '#')[1])
  //   let uri = new URI(pathname)
  //   uri.setQuery(key, value)
  //   href = window.location.origin + '/#' + uri.toString()
  //   replace ? window.history.replaceState({}, 0, href) : window.history.pushState({}, 0, href)
  // },
  // history模式下的
  setQuery (key, value, replace=false) {
    let href = this.getHref()
    let pathname = location.href
    let uri = new URI(pathname)
    uri.setQuery(key, value)
    href = uri.toString()
    replace ? window.history.replaceState({}, 0, href) : window.history.pushState({}, 0, href)
  }
}


// WEBPACK FOOTER //
// ./src/util/url.js